import {CookieEngine, LocalEngine, SessionEngine} from "./engines";

export const StorageType = {
  LOCAL: `LOCAL`,
  SESSION: `SESSION`,
  COOKIE: `COOKIE`,
};

const StorageClass = {
  LOCAL: LocalEngine,
  SESSION: SessionEngine,
  COOKIE: CookieEngine,
};

/**
 *
 * @param {string} storageType - Передаем сюда данные из словаря StorageType
 */
const storage = (storageType) => {
  return new StorageClass[storageType]();
};

export {storage};
